import { Box, RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';

interface StatusButtonProps {
  status?: string;
}

export const StatusButton = styled(RawButton)<StatusButtonProps>`
  background-color: ${({ theme, status }) => {
    if (status === LockboxStatus.APPROVED
      || status === LockboxStatus.PARTIALLY_APPROVED
      || status === LockboxStatus.COMPLETED
      || status === LockboxStatus.PROCESSED_MANUALLY
      || status === LockboxStatus.REISSUE) {
      return theme.colors.successContainer;
    }

    if (status === LockboxStatus.DECLINED
      || status === LockboxStatus.CANCELED
      || status === LockboxStatus.VOID) {
      return theme.colors.dangerContainer;
    }

    if (status === LockboxStatus.PENDING) {
      return theme.colors.warningContainer;
    }

    if (status === LockboxStatus.DIVIDED) {
      return theme.colors.infoContainer;
    }

    return theme.colors.warningContainer;
  }};

  color: ${({ theme, status }) => {
    if (status === LockboxStatus.APPROVED
      || status === LockboxStatus.PARTIALLY_APPROVED
      || status === LockboxStatus.COMPLETED
      || status === LockboxStatus.PROCESSED_MANUALLY) {
      return theme.colors.success;
    }

    if (status === LockboxStatus.DECLINED
      || status === LockboxStatus.CANCELED
      || status === LockboxStatus.VOID) {
      return theme.colors.danger;
    }

    if (status === LockboxStatus.PENDING) {
      return theme.colors.warning;
    }

    if (status === LockboxStatus.DIVIDED) {
      return theme.colors.textAccent;
    }
  
    return theme.colors.warning;
  }};

  border: none;
  height: 40px;
  text-align: center;
  cursor: initial;
  font-weight: 700;
`;

interface StatusCardWrapperProps {
  status?: string;
  isHighlight?: boolean;
}

export const StatusCardWrapper = styled(Box)<StatusCardWrapperProps>`
  transition: all 0.5s ease-out;

  ${({ theme, isHighlight, status }) => {
    if (!isHighlight) {
      return {
        border: `1px solid ${theme.colors.border2}`,
      };
    }

    if (status === LockboxStatus.APPROVED
      || status === LockboxStatus.PARTIALLY_APPROVED
      || status === LockboxStatus.COMPLETED
      || status === LockboxStatus.PROCESSED_MANUALLY
      || status === LockboxStatus.REISSUE) {
      return {
        border: `2px solid ${theme.colors.success}`,
        boxShadow: `0px 6px 16px ${theme.colors.success}`,
      };
    }

    if (status === LockboxStatus.DECLINED
      || status === LockboxStatus.CANCELED
      || status === LockboxStatus.VOID) {
      return {
        border: `2px solid ${theme.colors.danger}`,
        boxShadow: `0px 6px 16px ${theme.colors.danger}`,
      };
    }

    if (status === LockboxStatus.PENDING) {
      return {
        border: `2px solid ${theme.colors.warning}`,
        boxShadow: `0px 6px 16px ${theme.colors.warning}`,
      };
    }

    if (status === LockboxStatus.DIVIDED) {
      return {
        border: `2px solid ${theme.colors.info}`,
        boxShadow: `0px 6px 16px ${theme.colors.info}`,
      };
    }
  }}
`;
